import {useContext, useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {faBars, faPhone, faShoppingCart, faXmark} from "@fortawesome/pro-solid-svg-icons";

import {Styled} from "./Navigation.styles"
import {MAIN_PAGE} from "../../../Routes";
import {Local_Data} from "../../../Context";
import useS115 from "../../../lib/Hooks/useS115";
import useBasket from "../../../lib/Hooks/useBasket";
import useLanguage from "../../../lib/Hooks/useLanguage";
import {isNavItemActive, NAV_ITEMS} from "../navigationItems";
import {Contact__Values} from "../../../PageValues";

const Navigation = () => {

    const [localData, setLocalData] = useContext<any>(Local_Data);

    const {totalCount: basketCount} = useBasket()

    const [isScrolled, setIsScrolled] = useState<boolean>(window.scrollY > 6)

    const {t} = useTranslation()

    const {navigatePage} = useS115()

    const {language, changeLanguage} = useLanguage()

    const location = useLocation()

    useEffect(() => {
        const onScroll = () => setIsScrolled(window.scrollY > 6)
        window.addEventListener('scroll', onScroll, {passive: true})
        return () => window.removeEventListener('scroll', onScroll)
    }, []);

    const toggleMenu = () => {
        setLocalData((state: any) => ({
            ...state,
            isMenuOpen: !state?.isMenuOpen
        }))
    }

    const openBasket = () => {
        setLocalData((state: any) => ({
            ...state,
            isMenuOpen: false,
            isBasketOpen: true
        }))
    }

    return (
        <Styled.Header $scrolled={isScrolled || !!localData?.isMenuOpen}>
            <Styled.Bar>
                <Styled.IconButton
                    onClick={toggleMenu}
                    aria-label={t('lbl_navigation_menu')}
                >
                    <Styled.BurgerIcon icon={localData?.isMenuOpen ? faXmark : faBars}/>
                </Styled.IconButton>

                <Styled.Logo
                    onClick={() => navigatePage(MAIN_PAGE)}
                    aria-label={'S115'}
                >
                    S115
                </Styled.Logo>

                <Styled.Nav>
                    {NAV_ITEMS.map((item) => {
                        const isActive = isNavItemActive(item, location.pathname)
                        return (
                            <Styled.NavItem
                                key={item.path}
                                $active={isActive}
                                onClick={() => navigatePage(item.path)}
                            >
                                <Styled.NavItemDot $active={isActive}/>
                                {t(item.labelKey)}
                            </Styled.NavItem>
                        )
                    })}
                </Styled.Nav>

                <Styled.RightGroup>
                    <Styled.CallLink href={`tel:${Contact__Values.phoneNumbers[0].replace(/\s/g, '')}`}>
                        <Styled.CallIcon icon={faPhone}/>
                        {Contact__Values.phoneNumbers[0]}
                    </Styled.CallLink>

                    <Styled.LanguageSwitch>
                        {['pl', 'en'].map((code) => (
                            <Styled.LanguageOption
                                key={code}
                                $active={language === code}
                                onClick={() => changeLanguage(code)}
                            >
                                {code}
                            </Styled.LanguageOption>
                        ))}
                    </Styled.LanguageSwitch>

                    <Styled.BasketButton onClick={openBasket}>
                        <Styled.BasketIcon icon={faShoppingCart}/>
                        <Styled.BasketLabel>{t('lbl_basket')}</Styled.BasketLabel>
                        {basketCount > 0 && (
                            <Styled.BasketBubble
                                key={basketCount}
                                initial={{scale: 0.6, opacity: 0}}
                                animate={{scale: 1, opacity: 1}}
                                transition={{type: 'spring', stiffness: 520, damping: 22}}
                            >
                                {basketCount}
                            </Styled.BasketBubble>
                        )}
                    </Styled.BasketButton>
                </Styled.RightGroup>
            </Styled.Bar>
        </Styled.Header>
    )
}
export default Navigation
